import React, { useRef } from 'react';
var VeltActivityLogHeaderFilterContentItemLabel = function (props) {
    var defaultCondition = props.defaultCondition, filterOption = props.filterOption, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-header-filter-content-item-label", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "filter-option": filterOption }, children));
};
export default VeltActivityLogHeaderFilterContentItemLabel;
